

































































































import { Vue, Component } from "vue-property-decorator";
import { ContractorNew as IContractorNew } from "@/api/models/contractor-new";
import { ContractorNewList as IContractorNewList } from "@/api/models/contractor-new-list";
import ContractorListItem from "@/components/contractors/ContractorListItem.vue";
import contractors, { ContractorsListParams } from "@/getinfo-api/contractors";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import CustomTable from "@/components/form/CustomTable.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import api from "@/getinfo-api";
import {
  getCurrentCompanyId,
  getCurrentEmployee,
  getCurrentUserId,
  isRoot
} from "@/plugins/roles";
import CField from "@/components/form/CField.vue";
import CPage from "@/components/form/CustomPage/CPage.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import { uniqBy } from "lodash";
import { ContractorSort, SortFields } from "@/plugins/sort-fields";

@Component({
  components: {
    CSingleSelect,
    CPage,
    CustomButton,
    CustomTable,
    ContractorListItem,
    CField,
    CBlock
  }
})
export default class ContractorList extends Vue {
  contractors: Array<IContractorNew> = [];
  showSpinner: boolean = false;
  contractorCount: number = 0;
  searchString: string = "";
  clientType?: "juridical" | "physical";
  offset: number = 0;
  limit: number = 30;
  sorted: SortFields<ContractorSort> = new SortFields(ContractorSort.updatedAt);
  form: ContractorsListParams = {
    searchPhysical: undefined,
    searchJuridical: undefined,
    snils: "",
    sort: this.sorted.sort,
    order: this.sorted.order,
    companyId: this.selectedCompanyId,
    userIds: !this.isEmployee && !this.root ? [this.userId] : undefined
  };

  data() {
    return {
      clientType: undefined
    };
  }

  get root() {
    return isRoot();
  }

  get userId() {
    return getCurrentUserId();
  }

  get isEmployee() {
    return !!getCurrentEmployee();
  }

  get sortStatus() {
    return ContractorSort;
  }

  routeToCreate() {
    this.$router.push({
      name: "importContractors"
    });
  }

  showMoreContractor() {
    this.offset += this.limit;
    this.getContractorsByFilter(this.offset);
  }

  get selectedCompanyId() {
    return getCurrentCompanyId();
  }

  applyFilter() {
    this.offset = 0;
    this.contractors = [];
    this.getContractorsByFilter();
  }

  acceptSort(sort: ContractorSort) {
    this.sorted.changeSort(sort);
    this.form.sort = this.sorted.sort;
    this.form.order = this.sorted.order;
    this.applyFilter();
  }

  async getContractorsByFilter(offset: number = 0) {
    this.showSpinner = true;
    this.form.searchJuridical = undefined;
    this.form.searchPhysical = undefined;

    if (this.clientType) {
      try {
        this.showSpinner = true;
        this.form.type = this.clientType;

        this.form.searchPhysical =
          this.clientType === "physical" ? this.searchString : undefined;
        this.form.searchJuridical =
          this.clientType === "juridical" ? this.searchString : undefined;

        let params: ContractorsListParams = {
          ...this.form,
          offset: offset,
          limit: this.limit
        };

        const { data } = await contractors(params);
        this.contractorCount = data.count;
        this.contractors = uniqBy([...this.contractors, ...data.items], "id");
      } finally {
        this.showSpinner = false;
      }
    } else {
      let params: ContractorsListParams = {
        ...this.form,
        offset: offset,
        limit: this.limit
      };
      contractors(params)
        .then((res: { data: IContractorNewList }) => {
          this.contractorCount = res.data.count;
          this.contractors = uniqBy(
            [...this.contractors, ...res.data.items],
            "id"
          );
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        })
        .finally(() => {
          this.showSpinner = false;
        });
    }
  }

  clearFilter() {
    this.contractors = [];
    this.searchString = "";
    this.form.snils = "";
    this.clientType = undefined;
    this.form.type = undefined;
    this.getContractorsByFilter();
  }

  removeContractor(id: string) {
    api.ContractorApi.deleteContractorNew(id).then(() => {
      this.contractors = this.contractors.filter(el => el.id !== id);
    });
  }

  created() {
    this.getContractorsByFilter();
  }
}
